import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import ShareclassCardLabelValue from './ShareclassCardLabelValue';
import Icon from './Icon';
import getConditionalData from '../utils/query/getConditionalData';
import getConditionalDataFlag from '../utils/query/getConditionalDataFlag';
import normalizeQueryResults from '../utils/query/normalizeQueryResults';

const ShareclassCardWrapper = styled<any, any>('div')`
    ${propStyles};
`;

ShareclassCardWrapper.defaultProps = {
    display: 'flex',
    flexDirection: 'column',
    margin: 'md',
    bgColor: 'white',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
    boxShadow: 'sm',
};

export const ShareclassCardList = styled<any, any>('ul')`
    ${propStyles};
`;

ShareclassCardList.defaultProps = {
    display: 'flex',
    flexDirection: 'column',
    paddingX: 'md',
};

export const ShareclassCardRow = styled<any, any>('li')`
    ${propStyles};
    position: relative;
    list-style: none;
`;

ShareclassCardRow.defaultProps = {
    display: 'flex',
    flex: '1 0 auto',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    paddingY: 'md',
    fontSize: 'sm',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'none none solid none',
};

const ExpandIcon = styled<any, any>(Icon)`
    transition: transform 300ms ease-in-out;
    &.open {
        transform: rotate3d(1, 0, 0, 180deg);
    }
`;

ExpandIcon.defaultProps = {
    color: 'primary',
};

const ShareclassCardExpandButton = styled<any, any>('button')`
    ${propStyles};
    outline: none;
    cursor: pointer;
`;

ShareclassCardExpandButton.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginX: 'md',
    marginY: 'md',
    borderStyle: 'none',
    borderWidth: '0',
    bgColor: 'transparent',
};

const ShareclassCards: React.SFC<any> = ({
    theme,
    alternated,
    rowType,
    rowHasExpandableOptions,
    setSelectedGroup,
    selectedGroupMap,
    children,
    rowExpanderConfig,
    dataStore,
    ...shareClassProp
}) => {
    const fileName = shareClassProp.expanded
        ? (rowExpanderConfig && rowExpanderConfig.mobileCollapseIconFileName) ||
          'MobileCollapseIcon'
        : (rowExpanderConfig && rowExpanderConfig.mobileExpandIconFileName) ||
          'MobileExpandIcon';

    let rowExpandable = true;
    if (rowExpanderConfig && rowExpanderConfig.disabledFlag) {
        const conditionalConfig = rowExpanderConfig.disabledFlag;
        const values = normalizeQueryResults({
            ...shareClassProp.shareClass.properties_pub,
            ...getConditionalData(shareClassProp.shareClass, conditionalConfig),
        });
        rowExpandable = !getConditionalDataFlag(values, conditionalConfig);
    }

    return (
        <ShareclassCardWrapper
            data-alternated={alternated}
            {...theme.ShareclassCardWrapper}
        >
            <ShareclassCardList {...theme.ShareclassCardList}>
                {shareClassProp.columns.map((column, index) => (
                    <ShareclassCardRow
                        key={`${column.label}-${index}`}
                        onClick={
                            column.type === 'download'
                                ? shareClassProp.toggleExpanded
                                : () => null
                        }
                        cursor={column.type === 'download' ? 'pointer' : 'auto'}
                        {...theme.ShareclassCardRow}
                    >
                        <ShareclassCardLabelValue
                            shareClass={shareClassProp}
                            column={column}
                            columnIndex={index}
                            setSelectedGroup={setSelectedGroup}
                            selectedGroupMap={selectedGroupMap}
                        />
                    </ShareclassCardRow>
                ))}
            </ShareclassCardList>
            {shareClassProp.expanded && children}
            {rowExpandable && rowType !== 'Documents' && (
                <ShareclassCardExpandButton
                    onClick={shareClassProp.toggleExpanded}
                    {...theme.ShareclassCardExpandButton}
                >
                    <Icon
                        iconSize="1.4em"
                        fileName={fileName}
                        {...theme.ShareclassCardExpandIcon}
                    />
                </ShareclassCardExpandButton>
            )}
        </ShareclassCardWrapper>
    );
};

export default withTheme(observer(ShareclassCards)) as any;



// WEBPACK FOOTER //
// ./src/Components/ShareclassCards.tsx